import license from "./license.json";
export default license;
